import React from 'react'
import { useParams } from 'react-router-dom';

const Results = () => {
    const { seriesId } = useParams();

    return (
        <div>{seriesId} Series Results</div>
    )
}

export default Results